<template>
  <div>
    <header class="login-header" v-if="$store.getters.isLoaded">
      <div class="logo">
        <img v-if="$store.getters.settings.client.logo_2x" :src="$store.getters.settings.client.logo_2x"
             :srcset="$store.getters.settings.client.logo_4x +' 2x'"
             alt="logo">
      </div>
      <a v-if="$store.getters.settings.client.bilingual" :href="switchPath" class="language-toggle--overlay">عربي</a>
    </header>
    <main role="main" class="intro-pages-content">
      <section class="website-section website-form">
        <div class="container container--small">
          <header>
            <h1>{{ $store.getters.settings.appName }}</h1>
          </header>
          <form class="form-wrapper" v-on:submit.prevent="loginSubmit()">
            <fieldset>
              <legend class="legend-title">Member Login</legend>
              <input class="form-input"
                     type="text"
                     v-model="data.body.login"
                     @blur="$v.data.body.login.$touch()"
                     :class="{'is-invalid':$v.data.body.login.$error}"
                     placeholder="Email">
              <input class="form-input"
                     type="password"
                     @blur="$v.data.body.password.$touch()"
                     :class="{'is-invalid':$v.data.body.password.$error}"
                     v-model="data.body.password"
                     placeholder="Password">
              <div class="form-actions">
                <a class="t-text-color form-actions__link" href="#" @click.prevent="showForgotModal = true">
                  Forgot Password?
                </a>
                <div class="form-btns-group">
                  <button type="submit" class="btn t-bg-color">
                    Login
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
          <div class="error" v-if="errorText">
            {{ errorText }}
          </div>
          <router-link :to="{name:'Signup'}" class="register-link t-text-color">Permission Request</router-link>
        </div>
      </section>
      <div class="popup" v-if="showForgotModal" @click.self="showForgotModal = false">
        <div class="popup-info">
          <div class="popup-close" @click="showForgotModal = false">&times;</div>
          <div class="popup-info__title">
            <p>Forgot Password?</p>
          </div>
          <div class="popup-info__message">
            Enter your email address and we'll send you a recovery link.
          </div>
          <div class="success" v-if="forgotSuccessText">
            {{ forgotSuccessText }}
          </div>
          <form v-on:submit.prevent="resetSubmit()">
            <input class="popup-input"
                   type="email"
                   @blur="$v.forgetData.email.$touch()"
                   :class="{'is-invalid':$v.forgetData.email.$error}"
                   v-model="forgetData.email"
                   placeholder="Enter your email">
            <button type="submit" class="popup-btn btn t-bg-color">Send</button>
            <div class="error " v-if="forgotErrorText">
              {{ forgotErrorText }}
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    computed: {
      switchPath () {
        return '/ar' + this.$route.path
      }
    },
    data () {
      return {
        showForgotModal: false,
        data: {
          body: {
            login: '',
            password: ''
          },
          rememberMe: true,
          fetchUser: false
        },
        forgetData: {
          email: ''
        },
        errorText: null,
        forgotErrorText: null,
        forgotSuccessText: null
      }
    },
    validations: {
      data: {
        body: {
          password: {
            required
          },
          login: {
            required,
            email
          }
        }
      },
      forgetData: {
        email: {
          required,
          email
        }
      }
    },
    created () {
      this.$store.dispatch('setIsLoaded', true)
      document.title = this.$store.getters.settings.appName
    },
    filters: {
      json: (value) => {
        return JSON.stringify(value, null, 2)
      }
    },
    methods: {
      resetSubmit () {
        this.forgotErrorText = ''
        this.forgotSuccessText = ''
        this.$v.forgetData.$touch()
        if (!this.$v.forgetData.$invalid) {
          let qs = require('qs')
          this.axios.post('/auth/forgot-password', qs.stringify(this.forgetData))
            .then(response => {
              if (response.data.success === 'success') {
                this.forgotSuccessText = 'An email has been sent with instructions for resetting your password'
                this.forgetData = {
                  name: ''
                }
                this.$v.forgetData.$touch()
                this.$v.forgetData.$reset()
              } else {
                this.forgotErrorText = response.data.errors[0]
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      loginSubmit () {
        this.errorText = ''
        this.$v.data.$touch()
        if (!this.$v.data.$invalid) {
          let redirect = this.$auth.redirect()
          let qs = require('qs')
          this.$auth.login({
            data: qs.stringify(this.data.body), // Vue-resource
            rememberMe: this.data.rememberMe,
            redirect: {
              name: redirect ? redirect.from.name : 'Home',
              params: redirect ? redirect.from.params : {},
              hash: redirect ? redirect.from.hash : ''
            },
            fetchUser: this.data.fetchUser,
            success (resp) {
              if (resp.data.success === 'error') {
                this.errorText = 'Invalid login or password'
              } else {
                this.$auth.fetch()
              }
            },
            error (res) {
              this.errorText = 'Invalid login or password'
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue